import { useEffect } from 'react';

import { getDocument } from '@atlaskit/browser-apis';

import { installScrollbarHarmonisation } from './install-scrollbar-harmonisation';

export function useScrollbarHarmonisation(isEnabled: boolean): void {
	useEffect(() => {
		if (!isEnabled) {
			return;
		}

		const targetDocument = getDocument();
		if (!targetDocument) {
			return;
		}

		return installScrollbarHarmonisation(targetDocument);
	}, [isEnabled]);
}
